import HystModal from 'hystmodal';
import 'hystmodal/dist/hystmodal.min.css';

const startModals = () => {
  /**
   * Модальные окна
   * см. https://addmorescripts.github.io/hystModal/index_ru.html
   */
  window.modalInstance = new HystModal({
    linkAttributeName: 'data-hystmodal',
    waitTransitions: true,
    fixedSelectors: '.is-sticky .hdr__fixer',
    beforeOpen: () => {
    },
    afterClose: () => {
    },
  });
  window.modalMenuInstance = new HystModal({
    linkAttributeName: 'data-menumodal',
    waitTransitions: true,
    backscroll: false,
    catchFocus: false,
  });
};
export default startModals;
